import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useState } from "react";
import PageShell from "../../components/PageShell";
import {
  PAGE_TABS_BAR_SX,
  PAGE_TAB_LIST_PROPS,
  TAB_PANEL_SX,
} from "../../utils/pageLayoutStyles";
import WardsTable from "./wardsTable.jsx";
import BedsTable from "./bedsTable.jsx";

const ManageWards = () => { 
  const [selectedTab, setSelectedTab] = useState("1");

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <PageShell title="WARDS / BEDS">
      <TabContext value={selectedTab}>
        <Box sx={PAGE_TABS_BAR_SX}>
          <TabList
            {...PAGE_TAB_LIST_PROPS}
            onChange={handleChange}
          >
            <Tab label="All Wards" value="1" />
            <Tab label="All Beds" value="2" />
          </TabList>
        </Box>
        <TabPanel value="1" sx={TAB_PANEL_SX}>
          <WardsTable />
        </TabPanel>
        <TabPanel value="2" sx={TAB_PANEL_SX}>
          <BedsTable />
        </TabPanel>
      </TabContext>
    </PageShell>
  );
};

export default ManageWards;
